<template lang="html">

  <div class="encuestas-view" id="encuestas">

    <h2>{{ $t('encuestas.titulo') }}</h2>
    <p v-if="conEncomiendaDeGestion" class="text-center"><strong>{{ $t('contenido_no_disponible_encomienda') }}</strong></p>
    <template v-else>
      <section class="listado-encuestas container row-between" v-if="data.length > 0">
        <template v-for="(encuesta, key) in data">
          <encuesta-el :prop="encuesta" :key="key"></encuesta-el>
        </template>
      </section>

      <p v-else class="no-encuestas">{{ $t('encuestas.zero') }}</p>
    </template>

  </div>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import encuestaEl from '@/components/parts/encuesta-el';

export default {
  name: 'modulo-encuestas',
  mounted() {

    if (!!this.userType) {
      this.requestEncuestas(this.userType);
    }

    if (this.$route.hash == "#encuestas") {
      let top = $("#encuestas").offset().top;

      $("html, body").animate({ scrollTop: top }, 1000);

    }


  },
  computed: {
    ...mapGetters({
      data: 'getEncuestas',
      colors: 'basicColors',
      style: 'getStyles',
      userType: 'getUserType',
      conEncomiendaDeGestion: 'getConEncomiendaDeGestion'
    })
  },
  components: {
    'encuesta-el': encuestaEl
  },
  methods: {
    ...mapActions(['requestEncuestas'])
  }
}
</script>

<style scoped lang="scss">
.encuestas-view {
  padding: 50px 0;
  width: 100%;
  display: inline-block;
  padding-bottom: 0;
}

h2 {
  font-weight: 800;
  width: 100%;
  font-size: 36px;
  margin-bottom: 25px;
}

.listado-encuestas {
  width: 100%;
  max-width: 800px;
}

.no-encuestas {
  width: 100%;
  text-align: center;
}


@media screen and (max-width: 767px) {

  .encuestas-view {
    padding: 25px 0;
    width: 100%;
    display: inline-block;
  }

}

@media screen and (max-width: 500px) {
  h2 {
    font-size: 24px;
    margin-bottom: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-encuestas.vue